export class KanbanTour {
    tourInitialStepsEN = [
        {
            target: '[data-v-step="videos"]',
            content: '<b>Videos</b>' +
                '<br>' +
                '<div class="text-left"><a style="color: lightblue" href="https://vimeo.com/manage/videos/853626327" target="_blank">Info Craft</a></div>' +
                '<iframe src="https://player.vimeo.com/video/853626327" width="288" height="162" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>' +
                '<br>' +
                '<div class="text-left"><a style="color: lightblue" href="https://vimeo.com/manage/videos/906645643" target="_blank">Info Industry</a></div>' +
                '<iframe src="https://player.vimeo.com/video/906645643" width="288" height="162" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>',
        },
        {
            target: '[data-v-step="newboard"]',
            content: 'Create new board by clicking here',
        },
        {
            target: '[data-v-step="history"]',
            content: 'View the history by clicking here',
        },
        {
            target: '[data-v-step="viewswitch"]',
            content: 'Switch views by clicking here',
        },
    ];
    tourInitialStepsDE = [
        {
            target: '[data-v-step="videos"]',
            content: '<b>Videos</b>' +
                '<br>' +
                '<div class="text-left"><a style="color: lightblue" href="https://vimeo.com/manage/videos/853626327" target="_blank">Info Handwerk</a></div>' +
                '<iframe src="https://player.vimeo.com/video/853626327" width="288" height="162" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>' +
                '<br>' +
                '<div class="text-left"><a style="color: lightblue" href="https://vimeo.com/manage/videos/906645643" target="_blank">Info Industrie</a></div>' +
                '<iframe src="https://player.vimeo.com/video/906645643" width="288" height="162" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>',
        },
        {
            target: '[data-v-step="newboard"]',
            content: 'Hier klicken um ein neues Board zu erstellen',
        },
        {
            target: '[data-v-step="history"]',
            content: 'Hier klicken um die Historie zu anzusehen',
        },
        {
            target: '[data-v-step="viewswitch"]',
            content: 'Hier klicken um die Ansicht zu wechseln',
        },
    ];
    tourInitialSteps(lang: string): any[] {
        switch (lang.toLocaleLowerCase()) {
            case 'de':
                return this.tourInitialStepsDE;
            default:
                return this.tourInitialStepsEN;
        }
    }

    //
    tourBoardExistsStepsEN = [
        {
            target: '[data-v-step="boardoptions"]',
            content: 'Click here to share boards with others',
        },
        {
            target: '[data-v-step="newflow"]',
            content: 'Click here to create a new flow',
        },
    ];
    tourBoardExistsStepsDE = [
        {
            target: '[data-v-step="boardoptions"]',
            content: 'Hier klicken das Board zu teilen und im Team zu arbeiten',
        },
        {
            target: '[data-v-step="newflow"]',
            content: 'Hier klicken um einen neuen Flow zu erstellen',
        },
    ];
    tourBoardExistsSteps(lang: string): any[] {
        switch (lang.toLocaleLowerCase()) {
            case 'de':
                return this.tourBoardExistsStepsDE;
            default:
                return this.tourBoardExistsStepsEN;
        }
    }

    //
    tourFlowExistsStepsEN = [
        {
            target: '[data-v-step="newcard"]',
            content: 'Click here to create a new card',
        },
    ];
    tourFlowExistsStepsDE = [
        {
            target: '[data-v-step="newcard"]',
            content: 'Hier klicken um eine neue Karte zu erstellen',
        },
    ];
    tourFlowExistsSteps(lang: string): any[] {
        switch (lang.toLocaleLowerCase()) {
            case 'de':
                return this.tourFlowExistsStepsDE;
            default:
                return this.tourFlowExistsStepsEN;
        }
    }
}